export function extractVerifyTokenFrom(location) {
  const { search } = location;
  return search.slice(1);
}
